<div class="book">
    <div class="page" *ngFor="let obj of objSCopyCaseEntryService.arrmCopyCaseEntryAssignIV;">
        <div class="subpage">
            <div class="row" style="display: grid;grid-template-columns: 70% 30%;">
                <div style="font-size: 18px;font-weight: 500;">
                    SANT GADGE BABA AMRAVATI UNIVERSITY
                </div>
                <div style="font-size: 13px;font-weight: 500;text-align: right;">
                    ANNEXURE - IV <br>
                    THIRD CATEGORIZER
                </div>
            </div>
            <div class="row">
                <div style="font-size: 12px;font-weight: 500;text-align: justify;">
                    Consoliated statement showing the Category of the Case & the Punishment recommended if any, by the
                    foil Categorizer to the examinees for use of Malpractices in the University Examinations.
                    <br>
                    <span style="font-weight: 600;">EXAM - SUMMER-2026</span>
                </div>
            </div>
            <div class="row">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="vertical-align: middle; width: 5%;text-align: center;">Case No</th>
                            <th style="vertical-align: middle; width: 25%;">Name of Examinee</th>
                            <th style="vertical-align: middle; width: 45%;">Name of Exam</th>
                            <th style="vertical-align: middle; width: 10%;">Roll No</th>
                            <th style="vertical-align: middle; width: 5%;">Category</th>
                            <th style="vertical-align: middle; width: 10%;">Punishment</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let obj1 of obj.data;let i = index">
                            <td style="text-align: center;font-weight: 600;">
                                {{obj1.case_no | number:'2.0-0'}} <br>
                            </td>
                            <td style="font-weight: 500;">
                                {{obj1.student_first_name}} {{obj1.student_middle_name}}
                                {{obj1.student_last_name}}
                            </td>
                            <td>
                                {{obj1.exam_name}}
                                ({{obj1.subject}})
                            </td>
                            <td style="text-align: center;">
                                {{obj1.student_seat_no}} <br>
                                ({{obj1.center_code}})
                            </td>
                            <td style="text-align: center;">
                                <label *ngIf="obj1.annex_IV_cat != 0">
                                    {{obj1.annex_IV_cat | number:'2.0-0'}}
                                </label>
                            </td>
                            <td style="font-size: 12px;">
                                {{obj1.annex_IV_punishment}}
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td style="font-size: 15px;text-align: center;font-weight: 600;" colspan="6">{{obj.annex_IV_assign}}</td>
                        </tr>
                    </tfoot>
                </table>

                <!-- <div style="font-size: 15px;text-align: center;font-weight: 600;">
                    {{obj.annex_IV_assign}}
                </div> -->
                <div style="font-size: 13px;text-align: right;font-weight: 500;margin-top: 1rem;">
                    Name & Signature of the Third Categorizer
                </div>
            </div>
        </div>
    </div>
</div>